import FormikInputGroup from 'components/formikFields/inputGroup';
import UploadImage from 'components/uploadImage';

const QualityFormComponent = ({
  setImages,
  images,
  existingUnits,
}: IQualityFormComponentProps) => {
  return (
    <>
      <div className="mt-8 px-3">
        <UploadImage images={images} setImages={setImages} />
      </div>
      <div className="mt-8">
        <FormikInputGroup
          name="existing"
          label="موجودی"
          required
          Options={existingUnits}
          optionName="existing_unit"
        />
      </div>
      <div className="mt-8">
        <button
          type="submit"
          className=" w-full text-white bg-primary py-4 rounded-lg mb-6"
        >
          ادامه
        </button>
      </div>
    </>
  );
};

export default QualityFormComponent;
